import { createStore } from 'vuex'
import api from '@/api/maker-gpt'
import axios from 'axios'

export default createStore({
  state: {
    collectionsData: { schema: {}, metrics: {} },
    activeUser: {
      user: {
        context: [],
        personalRoles: []
      },
      usage: {}
    },
    roles: [],
    models: [],
    stat: {},
    systemMessages: [], // {type: 'info/error', message: ''}
    schemas: {},
    databases: [],
    systemSettings: {},
    userMessage: '',
    prompts: [],
    prompt: ''
  },
  getters: {
    getActiveUser: (state) => state.activeUser,
    getBalance: (state) => state.activeUser.user.balance || 0,
    getUserMessage: (state) => state.userMessage,
    getRoles: (state) => [...state.roles, ...state.activeUser.user.personalRoles]
  },
  mutations: {
    setUser: function (state, user) {
      state.activeUser = user
      localStorage.setItem('accessKey', user?.user?.accessKey || '')
    },
    logout: function (state) {
      state.activeUser = {
        user: {
          context: [],
          personalRoles: []
        },
        usage: {}
      }
      localStorage.removeItem('accessKey')
    },
    setRoles: function (state, roles) {
      state.roles = roles
    },
    setUserRole: async function (state, newRole) {
      state.activeUser.user.role = [...state.roles, ...state.activeUser.user.personalRoles].find(el => el.name === newRole)?.role || {}
    },
    setModels: function (state, models) {
      state.models = models.filter(el => el.enabled)
    },
    setUserModel: async function (state, newModel) {
      state.activeUser.user.model = newModel
    },
    addUserContext: async function (state, context) {
      state.activeUser.user.context.push(context)
    },
    clearUserContext: async function (state) {
      state.activeUser.user.context = []
      // state.userMessage = 'Контекст очищен, начат новый диалог'
    },
    switchContext: async function (state) {
      state.activeUser.user.contextEnabled = !state.activeUser.user.contextEnabled
    },
    setStat: function (state, stat) {
      state.stat = stat
    },
    addSystemMessage: function (state, msg) {
      state.systemMessages.push(msg)
    },
    setDatabases: function (state, databases) {
      state.databases = databases
    },
    setSchemas: function (state, _s) {
      state.schemas = _s
    },
    setSystemSettings: function (state, _s) {
      state.systemSettings = _s
    },
    setUserPersonalRoles: function (state, personalRoles) {
      state.activeUser.personalRoles = personalRoles
    },
    clearUserMessage: function (state) {
      state.userMessage = ''
    },
    setPrompts: function (state, p) {
      state.prompts = p
    },
    setPrompt: function (state, p) {
      state.prompt = p
    }
  },
  actions: {
    setUserRole: async function ({ commit, state }, newRole) {
      commit('setUserRole', newRole)
      try {
        const _answer = await api.queryMakerGptAPI('/v1/user/role/set', { user: { accessKey: state.activeUser.user.accessKey }, role: state.activeUser.user.role })
        if (_answer) commit('addSystemMessage', { type: 'info', message: 'Установлена роль: ' + newRole })
      } catch (err) {
        console.log(err)
        commit('addSystemMessage', { type: 'error', message: err })
      }
    },
    setUserModel: async function ({ commit, state }, newModel) {
      try {
        const _answer = await api.queryMakerGptAPI('/v1/user/model/set', { user: { accessKey: state.activeUser.user.accessKey }, model: newModel })
        if (_answer) {
          commit('addSystemMessage', { type: 'info', message: 'Установлена модель: ' + newModel })
          commit('setUserModel', newModel)
        }
      } catch (err) {
        console.log(err)
        commit('addSystemMessage', { type: 'error', message: err })
      }
    },
    loadDatabases: async function ({ commit, state }) {
      // const _schemasData = await axios.get('https://api.maker-gpt.pro/db/v1/weaviate/schema')
      // commit('setSchemas', _schemasData.data)
      let _databases = await api.queryMakerGptAPI('/v1/db/get', { tags: [...state.activeUser.user.tags, state.activeUser.user.id] || [] })
      // const { metrics, schema } = _schemasData.data
      _databases = _databases
        .map(el => {
          // el.metrics = metrics ? metrics.find(c => c.object_count.class_name.toLowerCase() === el.name.toLowerCase()) : []
          // el.schema = schema ? schema.classes.find(c => c.class.toLowerCase() === el.name.toLowerCase()) : []
          el.metrics = []
          el.schema = []
          el.collapsed = true
          return el
        })
      commit('setDatabases', _databases)
      // console.log('setDatabases', _databases, metrics, schema)
    },
    switchContext: async function ({ commit, state }, contextEnabled) {
      // https://api.maker-gpt.pro/v1/user/context/switch
      // commit('switchContext')
      try {
        const _answer = await api.queryMakerGptAPI('/v1/user/context/switch', { user: { accessKey: state.activeUser.user.accessKey } })
        if (_answer) commit('addSystemMessage', { type: 'info', message: 'Контекст ' + (contextEnabled ? 'включен' : 'отключен') })
      } catch (err) {
        console.log(err)
        commit('addSystemMessage', { type: 'error', message: err })
      }
    },
    clearUserContext: async function ({ commit, dispatch, state }) {
      // https://api.maker-gpt.pro/v1/user/context/switch
      // commit('switchContext')
      try {
        const _answer = await api.queryMakerGptAPI('/v1/user/context/clear', { user: { accessKey: state.activeUser.user.accessKey } })
        if (_answer) {
          commit('clearUserContext')
          dispatch('showMessage', 'Контекст очищен, начат новый диалог')
        }
      } catch (err) {
        console.log(err)
        commit('addSystemMessage', { type: 'error', message: err })
      }
    },
    mainLoad: async function ({ commit, state, dispatch }) {
      // console.log('load user from localstorage: ', localStorage.getItem('accessKey'))
      const _user = await api.queryMakerGptAPI('/v1/user/get', { user: { accessKey: localStorage.getItem('accessKey') } })
      // console.log('Загружен пользователь: ', _user)
      commit('setUser', _user)
      // console.log('Загружаем данные с апи')
      const _m = await api.queryMakerGptAPI('/v1/system/models', { })
      // console.log('Загружены модели: ', _m)
      commit('setModels', _m)
      const _r = await api.queryMakerGptAPI('/v1/system/roles', { })
      // console.log('Загружены роли: ', _r)
      commit('setRoles', _r)
      const _ss = await api.queryMakerGptAPI('/v1/system/getsystemsettings', { })
      commit('setSystemSettings', _ss)
      // commit('setDatabases', await api.queryMakerGptAPI('/v1/db/get', { }))
      dispatch('loadDatabases')
      dispatch('showMessage', 'Данные загружены, система готова к работе')
      axios.get('https://chat.maker-gpt.pro/docs/prompts.json')
        .then(p => {
          commit('setPrompts', p.data?.prompts)
        })
    },
    reloadUser: function ({ commit, state, dispatch }) {
      if (state.activeUser.user.accessKey) {
        api.queryMakerGptAPI('/v1/user/get', { user: { accessKey: state.activeUser.user.accessKey } })
          .then(_user => {
            commit('setUser', _user)
          })
      }
    },
    showMessage: function ({ commit, state }, msg) {
      state.userMessage = msg
    },
    updateToDo: async function ({ commit, state }, tasks) {
      try {
        state.systemSettings.todos = tasks
        await api.queryMakerGptAPI('/v1/system/update', { systemSettings: { todos: state.systemSettings.todos, _id: state.systemSettings._id } })
      } catch (err) {
        console.log(err)
        commit('addSystemMessage', { type: 'error', message: err })
      }
    }
  },
  modules: {
  }
})
